<template>
  <div class="footer">
    <div class="footer__nav">
      <TabNavButton
        v-for="(item, index) in navItems"
        :key="index"
        :horizontal="true"
        :label="item.label"
        :theme="item.theme"
        :path="item.path"
        :picto-top="(item.config.intro.preview || [])[0]"
        :picto-bottom="(item.config.intro.preview || [])[1]"
        class="footer__button"
      />
    </div>
  </div>
</template>

<script>
import TabNavButton from '@/components/navigation/TabNavButton.vue';

export default {
  components: { TabNavButton },

  props: {
    config: { type: Object, default: null },
  },

  computed: {
    navItems() {
      const productRoutes = this.$store.getters.getCollectionRoutes();
      const itemMatch = item => this.$route.path.startsWith(item.path);
      return productRoutes.filter(item => !itemMatch(item)).map(r => ({
        label: r.label,
        path: r.path,
        theme: r.theme,
        config: this.$store.getters.getRouteConfig(r),
      }));
    },
  },
};
</script>

<style lang="stylus" scoped>
.footer {
  &--theme-green { background-color: $cl-green; }
  &--theme-purple { background-color: $cl-purple; }
  &--theme-orange { background-color: $cl-orange; }
}

.footer__button {
  width: 100%;
  height: 60px;
}
</style>
